(function () {
  var TARGET_HANDLE = 'luxe-lip-oil-hyaluronic-acid';

  function toStrings(list) {
    return (list || []).map(function (item) {
      return String(item);
    });
  }

  function parseConfig(root) {
    var script = root.querySelector('[data-custom-gallery-config]');
    if (!script) return null;
    try {
      var config = JSON.parse(script.textContent);
      config.variantMediaIds = toStrings(config.variantMediaIds || []);
      config.galleryMediaIds = toStrings(config.galleryMediaIds || []);
      config.mediaOrder = toStrings(config.mediaOrder || []);
      return config;
    } catch (error) {
      return null;
    }
  }

  function getFeaturedItems(root) {
    return Array.prototype.slice.call(
      root.querySelectorAll('.product-media--root[data-view="featured"] .product-media--featured')
    );
  }

  function getThumbItems(root) {
    return Array.prototype.slice.call(
      root.querySelectorAll('.product-media--root[data-view="thumbs"] .product-media--thumb')
    );
  }

  function getVariantSelect(root) {
    return root.querySelector('.product-form--variant-select');
  }

  function setSwatchOverrides(root) {
    Array.prototype.forEach.call(
      root.querySelectorAll('.radios--swatch-button[data-swatch-override="true"]'),
      function (swatch) {
        var image = swatch.getAttribute('data-swatch-image');
        var img = swatch.querySelector('.radios--swatch-image');
        if (!image) return;
        swatch.style.setProperty('background-image', 'none', 'important');
        swatch.style.setProperty('background-color', 'transparent', 'important');
        if (img && img.getAttribute('src') !== image) {
          img.setAttribute('src', image);
        }
      }
    );
  }

  function getCurrentVariantMediaId(root, config) {
    var select = getVariantSelect(root);
    var variantId = select && select.value ? String(select.value) : String(config.selectedVariantId || '');
    if (!variantId) return null;
    return config.variantMediaByVariantId && config.variantMediaByVariantId[variantId]
      ? String(config.variantMediaByVariantId[variantId])
      : null;
  }

  function pauseCurrentMedia(root) {
    var active = root.querySelector('.product-media--featured[data-active="true"] > *');
    if (window.jQuery && active) {
      window.jQuery(active).trigger('pause-media');
    }
  }

  function playCurrentMedia(target) {
    if (window.jQuery && target) {
      window.jQuery(target).children().trigger('play-media');
    }
  }

  function setActiveMedia(root, mediaId) {
    if (!mediaId) return;
    var featuredItems = getFeaturedItems(root);
    var thumbItems = getThumbItems(root);
    var wrapper = root.querySelector('.product-media--wrapper');
    var target = null;

    pauseCurrentMedia(root);

    featuredItems.forEach(function (item) {
      if (String(item.getAttribute('data-id')) === String(mediaId)) {
        target = item;
        item.setAttribute('data-active', 'true');
      } else {
        item.setAttribute('data-active', 'false');
      }
    });

    thumbItems.forEach(function (item) {
      if (String(item.getAttribute('data-id')) === String(mediaId)) {
        item.setAttribute('data-active', 'true');
      } else {
        item.setAttribute('data-active', 'false');
      }
    });

    if (wrapper && target) {
      wrapper.setAttribute('data-media-type', target.getAttribute('data-media-type') || 'image');
    }

    playCurrentMedia(target);
  }

  function syncGallery(root, config) {
    setSwatchOverrides(root);

    var currentVariantMediaId = getCurrentVariantMediaId(root, config);
    var order = [];

    if (currentVariantMediaId) {
      order.push(currentVariantMediaId);
    }

    config.galleryMediaIds.forEach(function (mediaId) {
      if (mediaId !== currentVariantMediaId) {
        order.push(mediaId);
      }
    });

    if (!order.length) {
      order = config.mediaOrder.slice();
    }

    root.__customGalleryOrder = order;
    root.__customGalleryCurrent = order[0] || null;

    if (root.__customGalleryCurrent) {
      setActiveMedia(root, root.__customGalleryCurrent);
    }
  }

  function move(root, direction) {
    var order = root.__customGalleryOrder || [];
    if (order.length < 2) return;

    var current = root.__customGalleryCurrent;
    if (!current) {
      var active = root.querySelector('.product-media--featured[data-active="true"]');
      current = active ? String(active.getAttribute('data-id')) : order[0];
    }

    var index = order.indexOf(String(current));
    if (index === -1) index = 0;

    index = direction === 'prev' ? index - 1 : index + 1;
    if (index < 0) index = order.length - 1;
    if (index >= order.length) index = 0;

    root.__customGalleryCurrent = order[index];
    setActiveMedia(root, root.__customGalleryCurrent);
  }

  function bindArrows(root) {
    var controls = root.querySelector('[data-custom-gallery-arrows]');
    if (!controls || controls.dataset.bound === 'true') return;
    controls.dataset.bound = 'true';

    controls.addEventListener('click', function (event) {
      var button = event.target.closest('.product-media--arrow');
      if (!button) return;
      event.preventDefault();
      move(root, button.getAttribute('data-direction'));
    });
  }

  function bindVariantChange(root, config) {
    var formRoot = root.querySelector('.product-form--root');
    if (!formRoot || formRoot.dataset.customGalleryBound === 'true') return;
    formRoot.dataset.customGalleryBound = 'true';

    formRoot.addEventListener('change', function () {
      window.requestAnimationFrame(function () {
        syncGallery(root, config);
      });
    });
  }

  function bindSwipe(root) {
    var wrapper = root.querySelector('.product-media--wrapper');
    if (!wrapper || wrapper.dataset.customGallerySwipeBound === 'true') return;
    wrapper.dataset.customGallerySwipeBound = 'true';

    var startX = 0;
    var startY = 0;

    wrapper.addEventListener('touchstart', function (event) {
      if (!event.changedTouches || !event.changedTouches.length) return;
      startX = event.changedTouches[0].clientX;
      startY = event.changedTouches[0].clientY;
    }, { passive: true });

    wrapper.addEventListener('touchend', function (event) {
      if (!event.changedTouches || !event.changedTouches.length) return;
      var endX = event.changedTouches[0].clientX;
      var endY = event.changedTouches[0].clientY;
      var deltaX = endX - startX;
      var deltaY = endY - startY;

      if (Math.abs(deltaX) < 35 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
      if (deltaX > 0) {
        move(root, 'prev');
      } else {
        move(root, 'next');
      }
    }, { passive: true });
  }

  function init(root) {
    if (!root || root.getAttribute('data-custom-gallery') !== 'true') return;
    var config = parseConfig(root);
    if (!config || config.productHandle !== TARGET_HANDLE) return;

    setSwatchOverrides(root);
    bindArrows(root);
    bindVariantChange(root, config);
    bindSwipe(root);
    syncGallery(root, config);
  }

  function initAll(scope) {
    Array.prototype.forEach.call(
      (scope || document).querySelectorAll('.product-page--root[data-custom-gallery="true"]'),
      init
    );
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
